import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: {
    type: "column"
  },

  title: {
    text: ""
  },
  legend: {
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal",
     
    },
    reversed: true
  },

  xAxis: {
    categories: ["To be invoiced", "BBND"]
  },

  yAxis: [
    {
      allowDecimals: false,
      min: 0,
      title: {
        text: "No. of Units"
      },
      labels: {
        style: { fontSize: "12px" }
      }
    }
  ],

  tooltip: {
    // shared: true,
    // headerFormat: '<b>Total:  {point.total}k </b><br>',
  },

  plotOptions: {
    column: {
      stacking: "normal"
    }
  },

  series: [
    {
      name: "<24 hrs",
      data: [381, 349],
      index:3,
      // data: [],
      stack: "male",
      color: "#00AFE3",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: "24-48",
      // data: [],
      data: [197, 167],
      index:2,
      stack: "male",
      color: "#73C8B1",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: "48-72",
      // data: [],
      data: [184, 182],
      index:1,
      stack: "male",
      color: "#F58F0F",
      tooltip: { valueSuffix: "  %" }
    },
    {
      name: ">72",
      data: [184, 182],
      index:0,
      stack: "male",
      color: "#EAC745",
      tooltip: { valueSuffix: " %" }
    },
  ]
};
